import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmAuthNeedVerifyPhoneError } from '@/core/error/transport/auth/TmAuthNeedVerifyPhoneError'

export const needVerifyPhoneErrorRule: CustomErrorRule = {
  subCodes: ['auth.phone_not_verified'],
  klass: TmAuthNeedVerifyPhoneError,
}
